var _path, _path2, _g, _ellipse, _path3, _path4, _g2, _ellipse2, _path5, _path6, _path7, _path8, _path9, _ellipse3, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 106,
    viewBox: "0 0 156 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.134 75.7293C25.7802 74.9644 20.7133 69.7753 17.3177 65.1202C15.6251 62.7997 12.0841 62.4641 10.2515 64.6757L3.15997 73.2345C1.95243 74.6919 1.91411 76.7934 3.17599 78.204C7.32842 82.8457 15.0261 90.0941 23.96 94.561C32.7927 98.9773 40.8198 99.2653 45.314 98.6481C46.814 98.4421 47.8926 97.2107 48.1608 95.7205L50.7923 81.1011C51.273 78.4306 49.031 76.0298 46.3214 76.1732C41.8973 76.4074 36.1167 76.4411 31.134 75.7293Z",
    fill: "url(#paint0_linear_2810_19986)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.134 75.7293C25.7802 74.9644 20.7133 69.7753 17.3177 65.1202C15.6251 62.7997 12.0841 62.4641 10.2515 64.6757L3.15997 73.2345C1.95243 74.6919 1.91411 76.7934 3.17599 78.204C7.32842 82.8457 15.0261 90.0941 23.96 94.561C32.7927 98.9773 40.8198 99.2653 45.314 98.6481C46.814 98.4421 47.8926 97.2107 48.1608 95.7205L50.7923 81.1011C51.273 78.4306 49.031 76.0298 46.3214 76.1732C41.8973 76.4074 36.1167 76.4411 31.134 75.7293Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4435 77.7288C25.0897 76.9639 20.0228 71.7748 16.6272 67.1197C14.9346 64.7993 11.3935 64.4636 9.56098 66.6752L2.46942 75.234C1.26188 76.6914 1.22355 78.7929 2.48544 80.2035C6.63787 84.8453 14.3356 92.0936 23.2695 96.5605C32.1021 100.977 40.1293 101.265 44.6234 100.648C46.1235 100.442 47.2021 99.2102 47.4703 97.72L50.1018 83.1006C50.5825 80.4301 48.3404 78.0293 45.6308 78.1727C41.2067 78.4069 35.4262 78.4406 30.4435 77.7288Z",
    fill: "url(#paint1_linear_2810_19986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4435 77.7288C25.0897 76.9639 20.0228 71.7748 16.6272 67.1197C14.9346 64.7993 11.3935 64.4636 9.56098 66.6752L2.46942 75.234C1.26188 76.6914 1.22355 78.7929 2.48544 80.2035C6.63787 84.8453 14.3356 92.0936 23.2695 96.5605C32.1021 100.977 40.1293 101.265 44.6234 100.648C46.1235 100.442 47.2021 99.2102 47.4703 97.72L50.1018 83.1006C50.5825 80.4301 48.3404 78.0293 45.6308 78.1727C41.2067 78.4069 35.4262 78.4406 30.4435 77.7288Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9777,
    cy: 85.0106,
    rx: 4.70794,
    ry: 3.45249,
    fill: "#DFEBEA",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.134 24.7297C27.7802 23.9649 22.7133 18.7758 19.3177 14.1207C17.6251 11.8002 14.0841 11.4646 12.2515 13.6762L5.15997 22.235C3.95243 23.6924 3.91411 25.7939 5.17599 27.2045C9.32842 31.8462 17.0261 39.0945 25.96 43.5615C34.7927 47.9778 42.8198 48.2657 47.314 47.6486C48.814 47.4426 49.8926 46.2112 50.1608 44.721L52.7923 30.1016C53.273 27.4311 51.031 25.0303 48.3214 25.1737C43.8973 25.4079 38.1167 25.4416 33.134 24.7297Z",
    fill: "url(#paint2_linear_2810_19986)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.134 24.7297C27.7802 23.9649 22.7133 18.7758 19.3177 14.1207C17.6251 11.8002 14.0841 11.4646 12.2515 13.6762L5.15997 22.235C3.95243 23.6924 3.91411 25.7939 5.17599 27.2045C9.32842 31.8462 17.0261 39.0945 25.96 43.5615C34.7927 47.9778 42.8198 48.2657 47.314 47.6486C48.814 47.4426 49.8926 46.2112 50.1608 44.721L52.7923 30.1016C53.273 27.4311 51.031 25.0303 48.3214 25.1737C43.8973 25.4079 38.1167 25.4416 33.134 24.7297Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4435 26.7293C27.0897 25.9644 22.0228 20.7753 18.6272 16.1202C16.9346 13.7997 13.3935 13.4641 11.561 15.6757L4.46942 24.2345C3.26188 25.6919 3.22355 27.7934 4.48544 29.204C8.63787 33.8457 16.3356 41.0941 25.2695 45.561C34.1021 49.9773 42.1293 50.2653 46.6234 49.6481C48.1235 49.4421 49.2021 48.2107 49.4703 46.7205L52.1018 32.1011C52.5825 29.4306 50.3404 27.0298 47.6308 27.1732C43.2067 27.4074 37.4262 27.4411 32.4435 26.7293Z",
    fill: "url(#paint3_linear_2810_19986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4435 26.7293C27.0897 25.9644 22.0228 20.7753 18.6272 16.1202C16.9346 13.7997 13.3935 13.4641 11.561 15.6757L4.46942 24.2345C3.26188 25.6919 3.22355 27.7934 4.48544 29.204C8.63787 33.8457 16.3356 41.0941 25.2695 45.561C34.1021 49.9773 42.1293 50.2653 46.6234 49.6481C48.1235 49.4421 49.2021 48.2107 49.4703 46.7205L52.1018 32.1011C52.5825 29.4306 50.3404 27.0298 47.6308 27.1732C43.2067 27.4074 37.4262 27.4411 32.4435 26.7293Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9777,
    cy: 34.0111,
    rx: 4.70794,
    ry: 3.45249,
    fill: "#DFEBEA",
    fillOpacity: 0.48
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1985 0.674805C67.5754 0.674805 75.9874 9.08693 75.9875 19.4639C75.9875 29.8409 67.5755 38.2529 57.1985 38.2529C46.8216 38.2528 38.4094 29.8408 38.4094 19.4639C38.4095 9.08701 46.8216 0.674929 57.1985 0.674805ZM63.9446 9.62207C63.1142 9.62207 62.4407 10.2956 62.4407 11.126V16.9199H57.1292L52.6086 10.415C52.2637 9.91856 51.6976 9.62214 51.093 9.62207C50.0736 9.62207 49.2465 10.4484 49.2463 11.4678V16.9199H48.3323C47.7936 16.9199 47.3569 17.3569 47.3567 17.8955C47.3567 18.4344 47.7934 18.8721 48.3323 18.8721H49.2463V21.1357H48.3323C47.7934 21.1357 47.3567 21.5725 47.3567 22.1113C47.3569 22.65 47.7935 23.0869 48.3323 23.0869H49.2463V28.0859C49.2463 28.9244 49.9264 29.6044 50.7649 29.6045C51.6034 29.6045 52.2834 28.9244 52.2834 28.0859V23.0869H58.1213L62.1096 28.8184C62.4524 29.3108 63.0145 29.6045 63.6145 29.6045C64.6272 29.6045 65.4485 28.7832 65.4485 27.7705V23.0869H66.3625C66.9013 23.0869 67.3379 22.65 67.3381 22.1113C67.3381 21.5725 66.9014 21.1357 66.3625 21.1357H65.4485V18.8721H66.3625C66.9014 18.8721 67.3381 18.4344 67.3381 17.8955C67.3379 17.3569 66.9013 16.9199 66.3625 16.9199H65.4485V11.126C65.4485 10.2956 64.775 9.6221 63.9446 9.62207ZM62.4407 24.1748C62.4404 24.2421 62.3859 24.2969 62.3186 24.2969C62.2786 24.2968 62.2408 24.277 62.218 24.2441L61.4143 23.0869H62.4407V24.1748ZM56.7639 21.1357H52.2834V18.8721H55.1887L56.7639 21.1357ZM62.4407 21.1357H60.0579L58.4856 18.8721H62.4407V21.1357ZM52.3987 14.9492C52.4366 14.9492 52.4727 14.9679 52.4944 14.999L53.8313 16.9199H52.2834V15.0654C52.2834 15.0016 52.3349 14.9494 52.3987 14.9492Z",
    fill: "#DFDFDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0276 72.6366C84.8056 71.2299 78.1039 74.0025 73.1487 76.9429C70.6787 78.4086 67.2918 77.3218 66.4791 74.567L63.334 63.9062C62.7984 62.091 63.5913 60.1443 65.3069 59.3451C70.9525 56.7153 80.8836 53.0867 90.8548 52.5016C100.713 51.9232 108.204 54.8217 112.091 57.1598C113.389 57.9403 113.895 59.4971 113.554 60.9724L110.212 75.4458C109.602 78.0896 106.595 79.4127 104.161 78.2132C100.187 76.2546 94.8877 73.9458 90.0276 72.6366Z",
    fill: "url(#paint4_linear_2810_19986)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0276 72.6366C84.8056 71.2299 78.1039 74.0025 73.1487 76.9429C70.6787 78.4086 67.2918 77.3218 66.4791 74.567L63.334 63.9062C62.7984 62.091 63.5913 60.1443 65.3069 59.3451C70.9525 56.7153 80.8836 53.0867 90.8548 52.5016C100.713 51.9232 108.204 54.8217 112.091 57.1598C113.389 57.9403 113.895 59.4971 113.554 60.9724L110.212 75.4458C109.602 78.0896 106.595 79.4127 104.161 78.2132C100.187 76.2546 94.8877 73.9458 90.0276 72.6366Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4384 69.5165C83.2164 68.1097 76.5147 70.8823 71.5595 73.8228C69.0895 75.2885 65.7026 74.2017 64.8899 71.4468L61.7447 60.7861C61.2092 58.9708 62.0021 57.0242 63.7177 56.225C69.3632 53.5951 79.2943 49.9666 89.2656 49.3815C99.1238 48.8031 106.615 51.7015 110.502 54.0397C111.8 54.8201 112.306 56.3769 111.965 57.8522L108.623 72.3257C108.012 74.9695 105.006 76.2926 102.572 75.0931C98.598 73.1345 93.2984 70.8257 88.4384 69.5165Z",
    fill: "url(#paint5_linear_2810_19986)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4384 69.5165C83.2164 68.1097 76.5147 70.8823 71.5595 73.8228C69.0895 75.2885 65.7026 74.2017 64.8899 71.4468L61.7447 60.7861C61.2092 58.9708 62.0021 57.0242 63.7177 56.225C69.3632 53.5951 79.2943 49.9666 89.2656 49.3815C99.1238 48.8031 106.615 51.7015 110.502 54.0397C111.8 54.8201 112.306 56.3769 111.965 57.8522L108.623 72.3257C108.012 74.9695 105.006 76.2926 102.572 75.0931C98.598 73.1345 93.2984 70.8257 88.4384 69.5165Z",
    fill: "black",
    fillOpacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.70794,
    cy: 3.45249,
    rx: 4.70794,
    ry: 3.45249,
    transform: "matrix(0.919088 0.394053 0.394053 -0.919088 83.2583 63.3926)",
    fill: "#DFEBEA",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.238 44.0122C120.676 43.6653 121.196 43.4129 121.753 43.2529V48.6392C121.203 48.4887 120.689 48.2313 120.238 47.8818C119.479 47.2787 119.186 46.5695 119.186 45.947C119.186 45.3246 119.479 44.6154 120.238 44.0122ZM124.644 57.3401V51.8979C125.312 52.0617 125.923 52.3373 126.419 52.7092C127.241 53.3259 127.534 54.0312 127.534 54.619C127.534 55.2068 127.241 55.9121 126.419 56.5288C125.887 56.9152 125.284 57.1924 124.644 57.3401Z",
    fill: "#DFDFDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.199 31.4937C112.821 31.4937 104.409 39.9055 104.409 50.2829C104.409 60.6604 112.821 69.0722 123.199 69.0722C133.576 69.0722 141.988 60.6604 141.988 50.2829C141.988 39.9055 133.576 31.4937 123.199 31.4937ZM124.644 38.7203C124.644 38.337 124.492 37.9694 124.221 37.6983C123.95 37.4272 123.582 37.275 123.199 37.275C122.815 37.275 122.448 37.4272 122.177 37.6983C121.906 37.9694 121.753 38.337 121.753 38.7203V40.2928C120.545 40.4962 119.406 40.9968 118.439 41.7497C117.067 42.8405 116.296 44.3513 116.296 45.947C116.296 47.5445 117.067 49.0535 118.441 50.1442C119.408 50.915 120.564 51.391 121.753 51.6011V57.34C121.113 57.1916 120.509 56.9157 119.978 56.5287L118.284 55.2568C118.133 55.1429 117.96 55.0601 117.776 55.013C117.592 54.9659 117.401 54.9554 117.213 54.9823C116.833 55.0365 116.491 55.2392 116.261 55.5459C116.031 55.8525 115.932 56.238 115.986 56.6175C116.041 56.9969 116.243 57.3393 116.55 57.5693L118.244 58.8412C119.271 59.6121 120.497 60.0842 121.753 60.2866V61.8456C121.753 62.2289 121.906 62.5965 122.177 62.8676C122.448 63.1386 122.815 63.2909 123.199 63.2909C123.582 63.2909 123.95 63.1386 124.221 62.8676C124.492 62.5965 124.644 62.2289 124.644 61.8456V60.2846C125.913 60.0939 127.117 59.5987 128.153 58.8412C129.589 57.764 130.425 56.2512 130.425 54.6189C130.425 52.9867 129.589 51.4739 128.153 50.3966C127.117 49.6384 125.913 49.1425 124.644 48.9513V43.2567C125.203 43.4147 125.721 43.6672 126.159 44.0141L126.958 44.65C127.259 44.8884 127.641 44.9978 128.022 44.9541C128.403 44.9104 128.751 44.7171 128.99 44.4168C129.228 44.1166 129.337 43.7339 129.294 43.353C129.25 42.972 129.057 42.6241 128.756 42.3857L127.957 41.7497C126.99 40.9978 125.852 40.4979 124.644 40.2947V38.7203Z",
    fill: "#DFDFDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2810_19986",
    x1: 11.5026,
    y1: 60.0361,
    x2: 44.7877,
    y2: 108.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2810_19986",
    x1: 10.8121,
    y1: 62.0356,
    x2: 44.0971,
    y2: 110.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2810_19986",
    x1: 13.5026,
    y1: 9.03662,
    x2: 46.7877,
    y2: 57.6629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2810_19986",
    x1: 12.8121,
    y1: 11.0361,
    x2: 46.0971,
    y2: 59.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2810_19986",
    x1: 65.8007,
    y1: 79.3241,
    x2: 115.554,
    y2: 47.7484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2810_19986",
    x1: 64.2115,
    y1: 76.204,
    x2: 113.965,
    y2: 44.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.49c3ca5c26be6e0e7d741068ab4a32ba.svg";
export { ForwardRef as ReactComponent };